module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"engine":"Engine","maxTokens":"Max tokens","frequencyPenalty":"Frequency penalty","presencePenalty":"Presence penalty","temperature":"Temperature","topProbability":"Top probability","stop":"Stop"}}')
  delete Component.options._Ctor
}
